import React, {useState, useCallback, useEffect} from 'react';
import styled from 'styled-components';
// import {useNavigate} from 'react-router-dom';

// import {BITTERSWEET, OzContainer, OzBreadcrumbs, OzCard, Button, OzRow, Col, Input, Select} from '@ozwol/webui';

import Container from '../../common/components/Container';
import Row from '../../common/components/Row';
import Col from '../../common/components/Col';
import Card from '../../common/components/Card';
import Input from '../../common/components/Input';
import Select from '../../common/components/Select';
import Button from '../../common/components/Button';

import DatabaseService from '../../services/DatabaseService';

import {testValidField} from './../../helpers';

const ErrorMessage = styled.div.withConfig({displayName:'-ErrorMessage'})`
  height: 30px;
  color: red;
`;

const UsersNew = ({
  fnSuccess,
  fnCancel
}) => {
    // let navigate = useNavigate();
  const [item, setItem] = useState();

  const [disabled, setDisabled] = useState(true);
  const [errorMessage, setErrorMessage] = useState(false);

  useEffect(() => {
    setErrorMessage(null);
    let valid = true;
    if(item){
      if(!testValidField(item.given_name, true)){
        valid = false;
      }
      if(!testValidField(item.family_name, true)){
        valid = false;
      }
      if(!testValidField(item.address, true)){
        valid = false;
      }
      if(!testValidField(item.email, true)){
        valid = false;
      }
    }else{
      valid = false;
    }
    setDisabled(!valid);
  }, [item]);

  const addItem = useCallback((item) => {
    setErrorMessage("");
    DatabaseService.createUtente(item).then((response) => {
      window.location.reload();
    }).catch(error => {
      setErrorMessage(error.response.data.detail);
    });
  }, []);

  return (
    <Container size="medium">
      <Card
        footerLeft={<Button onClick={() => fnCancel()}>Indietro</Button>}
        footerRight={<Button onClick={disabled ? () => {} : () => addItem(item)} variant={disabled ? "disabled" : "default"} disabled={disabled}>Salva</Button>}
      >
        <Row>
            <Col widthmd="6">
            <Input
                required
                label="Cognome"
                width="100%"
                value={item && item.family_name ? item.family_name : ""}
                onChange={(val) => {
                let tempItem = {...item};
                tempItem.family_name = val;
                setItem(tempItem);
                }}
            />
            </Col>
            <Col widthmd="6">
            <Input
                required
                label="Nome"
                width="100%"
                value={item && item.given_name ? item.given_name : ""}
                onChange={(val) => {
                let tempItem = {...item};
                tempItem.given_name = val;
                setItem(tempItem);
                }}
            />
            </Col>
            <Col widthmd="6">
            <Select
                required
                label="Società"
                maxHeight={"200px"}
                values={[{
                  "name": "ENEL",
                  "value": "ENEL",
                },{
                  "name": "CESI",
                  "value": "CESI",
                },{
                  "name": "HIT MP",
                  "value": "HIT MP",
                }]}
                width={"100%"}
                selected={item && item.address ? item.address : null}
                onChange={(val) => {
                let tempItem = {...item};
                tempItem.address = val;
                setItem(tempItem);
                }}
            />
            </Col>
            <Col widthmd="6">
            <Input
                required
                label="Email"
                width="100%"
                value={item && item.email ? item.email : ""}
                onChange={(val) => {
                let tempItem = {...item};
                tempItem.email = val;
                setItem(tempItem);
                }}
            />
            </Col>


        </Row>
        <ErrorMessage>
          <br/>{errorMessage}<br/>
        </ErrorMessage>
      </Card>
    </Container>
  )
}

export default UsersNew;
